import styled from 'styled-components';
import { COLORS, FLEX_CONTAINER, FONT_FAMILY, FONTS } from 'utils/styles';
import { SIZE } from 'assets/styles/ScreenSize';

export const SuggestionsWrapper = styled.div`
  width: 100%;
  height: auto;
  ${FLEX_CONTAINER.FlexRow};
  flex-wrap: wrap;
  row-gap: 20px;
  column-gap: 20px;
  padding-top: 20px;
  padding-bottom: 20px;

  @media only screen and (max-width: ${SIZE.tablet}) {
    justify-content: center;
  }
`;

export const SuggestionBlock = styled.div`
  width: 250px;
  height: auto;
  padding-bottom: 20px;
  background: ${COLORS.white};
  border-radius: 16px;
  cursor: pointer;
`;

export const SuggestionImage = styled.div`
  background-image: ${({ image }) => `url(${image})`};
  width: 100%;
  height: 160px;
  background-size: cover;
  border-radius: 16px 16px 0 0;
  background-repeat: no-repeat;
  background-position: center;
`;

export const SuggestionTitleDescriptionBlock = styled.div`
  padding-left: 8px;
  ${FLEX_CONTAINER.FlexColumn};
  align-items: unset;
`;

export const SuggestionTitle = styled.span`
  color: ${COLORS.mainColor};
  ${FONTS.font20};
  ${FONT_FAMILY.FontBold};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const SuggestionDescription = styled.span`
  color: ${COLORS.mainColor};
  ${FONTS.font14};
  ${FONT_FAMILY.FontRegular};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;
